import { X as Close } from '@styled-icons/bootstrap/X';
import React from 'react';
import styled from 'styled-components';
import { useBrowser } from 'hooks';
import { Container, CloseButton, Item, ItemsContainer } from './styles';
import BatchHeader from './BatchHeader';
import { BoxArrowInUpRight } from '@styled-icons/bootstrap/BoxArrowInUpRight';
import Tooltip from '../Tooltip';
import { useTranslation } from 'react-i18next';
const Value = styled.div `
  font-size: 24px;
  font-weight: 700;
  font-family: Montserrat, sans-serif;
`;
const Label = styled.div `
  font-size: 11px;
  font-weight: 400;
  color: ${({ theme }) => theme.backgrounds.grey};
`;
const LabelSubItem = styled.div `
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.grey['A500']};
`;
const ValueSubItem = styled.div `
  font-size: 16px;
  font-weight: 700;
  ${({ centered }) => centered &&
    `display: flex;;
    justify-content: center;
    width: 100%;`}
`;
const LabelContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.grey['A500']};
`;
const ValueContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const Divider = styled.div `
  margin-top: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;
const HeaderContainer = styled.div `
  margin-right: 24px;
`;
const OriginBatchTraceContainer = ({ items, subItems, activityImage, selectedRawMaterial, hideLocationPin, hasOtherIngredients, onClose, onClick, }) => {
    const { isMobile } = useBrowser();
    const { t } = useTranslation();
    return (React.createElement(Container, { isMobile: isMobile },
        React.createElement(HeaderContainer, null,
            React.createElement(BatchHeader, { hideLocationPin: hideLocationPin, image: activityImage, rawMaterialTitle: selectedRawMaterial === null || selectedRawMaterial === void 0 ? void 0 : selectedRawMaterial.title, noRawMaterialSelected: !selectedRawMaterial, hasOtherIngredients: hasOtherIngredients })),
        (!!onClose || !!onClick) && (React.createElement(CloseButton, { onClick: isMobile ? onClick : onClose }, isMobile ? (React.createElement(BoxArrowInUpRight, { width: 24 })) : (React.createElement(Tooltip, { tooltipText: t('close-batch-tracing-tooltip') },
            React.createElement(Close, { width: 24 }))))),
        !!selectedRawMaterial && (React.createElement(React.Fragment, null,
            React.createElement(ItemsContainer, null, items.map(({ value, label }) => (React.createElement(Item, { key: `${label}-${value}` },
                React.createElement(Value, null, value === undefined ? '-' : value),
                React.createElement(Label, null, label))))),
            subItems && subItems.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement(ItemsContainer, { marginTop: 8 }, subItems.map((subItem) => (React.createElement(Item, { key: `${subItem.label}-${subItem.value}` },
                    React.createElement(LabelContainer, null,
                        subItem.labelIcon,
                        React.createElement(LabelSubItem, null, subItem.label)),
                    React.createElement(ValueContainer, null,
                        subItem.valueIcon,
                        React.createElement(ValueSubItem, { centered: subItem.value === undefined }, subItem.value === undefined ? '-' : subItem.value))))))))))));
};
export default OriginBatchTraceContainer;
